import { toast } from 'react-toastify'
import { deleteUrls } from 'services/api.enums'
import { deleteDataAPI } from 'services/CRUDServices'

export function useDeleteArea(setOpenDeleteModal, getZoneInfo) {
  const handleDeleteOperation = async (Data) => {
    try {
      await deleteDataAPI(deleteUrls.deleteZone, '', true, {
        province: { id: Data.id, text: '' },
        hubId: Data.selectHub.id,
      })
      setOpenDeleteModal(false)
      toast.success('منطقه عملیاتی با موفقیت حذف شد ')
      getZoneInfo()
    } catch (error) {}
  }

  return { handleDeleteOperation }
}

export default useDeleteArea
